import React, { useMemo, useRef, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;
    const tips = {
      ".ql-bold": "Bold",
      ".ql-italic": "Italic",
      ".ql-underline": "Underline",
      ".ql-strike": "Strikethrough",
      ".ql-list[value='ordered']": "Numbered list",
      ".ql-list[value='bullet']": "Bullet list",
      ".ql-blockquote": "Quote",
      ".ql-link": "Insert link",
      ".ql-clean": "Clear formatting",
      ".ql-header .ql-picker-label": "Text style (heading / normal)",
    };
    Object.entries(tips).forEach(([sel, title]) => {
      root.querySelectorAll(sel).forEach((el) => el.setAttribute("title", title));
    });
  }, []);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        ["link"],
        ["clean"],
      ],
      clipboard: { matchVisual: false },
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "blockquote",
    "link",
  ];

  return (
    <div className="rich-text-editor" ref={wrapperRef}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
